import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ReservationContractsTab } from '@mews-commander/contracts';
import { ArticlePath, createGuideLink, FeatureFlag, RouteName, TextKey } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute(
    '/_authenticated/$currentEnterpriseId/Reservation/Detail/$reservationId/Contracts'
)({
    validateSearch: z.object({
        reservationIds: z.string().optional(),
    }),
    component: Component,
    staticData: {
        title: TextKey.ReservationDetails,
        routeName: RouteName.ReservationDetailContracts,
        owner: MewsTeam.Spacetime,
        type: RouteType.Frontend,
        guideLink: createGuideLink(ArticlePath.WhatReservationModuleWhatFeatures),
    },
    beforeLoad: ({ context: { checkFeatureFlag } }) => {
        checkFeatureFlag(FeatureFlag.contractingManualDocumentsEnabled);
    },
});

function Component() {
    const { reservationId } = Route.useParams();

    return <ReservationContractsTab reservationId={reservationId} />;
}
